import { PlatformSiteAri } from '@atlassian/ari';

/**
 * Creates a Platform site ARI from a site ID
 * Safely handles invalid siteIds by returning null on failure
 * @param siteId - The site ID
 * @returns The platform site ARI string in format "ari:cloud:platform::site/{siteId}", or null if creation fails
 */
export const createPlatformSiteAri = (siteId: string | null | undefined): string | null => {
	if (!siteId) {
		return null;
	}
	try {
		return PlatformSiteAri.create({ siteId }).toString();
	} catch {
		return null;
	}
};
